require('./brokerConsultMiFIDItem.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');

class BrokerConsultMiFIDItem extends Component {
    constructor(props) {
        super(props);
    }


    buildContent() {
        const { items, isHeader } = this.props;
        const styleHeader = isHeader ? 'consult-result-mifid-item__headers' : 'consult-result-mifid-item__items'
        const listHeader = items.map((item, index) => {
            const style = items.length !== (index + 1) ? 'consult-result-mifid-item__item' : 'consult-result-mifid-item__last-item';
            return (
                <div className={style}>
                    {item}
                </div>
            )
        })
        return (
            <div className={styleHeader}>
                {listHeader}
            </div>
        )
    }

    render() {
        return (
            <div className='consult-result-mifid-item'>
                {this.buildContent()}
            </div>
        )
    }

}

BrokerConsultMiFIDItem.defaultProps = {
    isHeader: false,
}

BrokerConsultMiFIDItem.propTypes = {
    headers: PropTypes.array,
    items: PropTypes.array,
    isHeader: PropTypes.bool,
};

module.exports = BrokerConsultMiFIDItem;
